import api from '@pray/shared/utils/api';
import type { SuccessResponse } from '@pray/shared/utils/api/types/response';

export type UpdateSlotLimitParams = {
  slotKey: string;
  limit: number;
};

export type UpdateSlotLimitResponse = {
  success: boolean;
  message?: string;
};

type ApiUpdateSlotLimitResponse = SuccessResponse<UpdateSlotLimitResponse>;

/* eslint-disable camelcase */
type UpdateSlotLimitPayload = {
  slot_key: string;
  limit: number;
};
/* eslint-enable camelcase */

export async function updateSlotLimit(
  artistId: string,
  { slotKey, limit }: UpdateSlotLimitParams
): Promise<UpdateSlotLimitResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!slotKey) throw new Error('Slot key is required');
  if (typeof limit !== 'number' || limit < 0) throw new Error('Limit must be a non-negative number');

  const url = `/web/studio/artists/${artistId}/queues/slots`;
  /* eslint-disable camelcase */
  const payload: UpdateSlotLimitPayload = { slot_key: slotKey, limit };
  /* eslint-enable camelcase */
  const response = await api.executePutRequest<ApiUpdateSlotLimitResponse>(url, payload);

  return response.data.data[0].resource;
}
